var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49389 0.856984L5.05482 3.29603C5.05011 3.30072 5.04718 3.30641 5.04249 3.31115C5.64336 3.22363 6.26063 3.28363 6.83284 3.50676L8.48823 1.85137C9.03664 1.30295 9.92855 1.30295 10.477 1.85137C11.0254 2.39973 11.0254 3.2917 10.477 3.84006C10.3835 3.93362 7.8969 6.42018 8.03792 6.27911C7.48517 6.83191 6.57833 6.80826 6.04918 6.27911C5.77513 6.00505 5.32892 6.00505 5.05482 6.27911L4.62793 6.706C4.74634 6.90719 4.88209 7.10078 5.05482 7.27352C6.09638 8.31508 7.88921 8.39828 9.01719 7.28584C9.0219 7.28116 9.02757 7.2782 9.0323 7.27352L11.4714 4.83447C12.5697 3.73609 12.5697 1.95536 11.4714 0.856984C10.373 -0.241391 8.59227 -0.241391 7.49389 0.856984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76301 8.55426L4.10228 10.215C3.55391 10.7634 2.66195 10.7634 2.11358 10.215C1.56517 9.66658 1.56517 8.77466 2.11358 8.22625L4.55795 5.78188C5.1107 5.22913 6.01754 5.25274 6.54669 5.78188C6.82074 6.05599 7.26697 6.05599 7.54105 5.78188L7.96794 5.35499C7.84953 5.15381 7.71378 4.96021 7.54105 4.78752C6.50148 3.74791 4.70996 3.65945 3.57868 4.77517C3.57397 4.77986 3.5683 4.78281 3.56356 4.78752L1.11917 7.23192C0.0208457 8.33024 0.0207989 10.111 1.11917 11.2094C2.21755 12.3077 3.99833 12.3077 5.09666 11.2094L7.54103 8.76499C7.54574 8.7603 7.54867 8.75465 7.55335 8.74987C6.95249 8.83738 6.33524 8.77738 5.76301 8.55426Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.29541 0.0332031)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.87718017ea695de0ddeda1e3743a6572.svg";
export { ForwardRef as ReactComponent };